/** Mirrors backend FeedbackTypeContract (PascalCase strings on the wire). */
export enum FeedbackType {
  Wish = "Wish",
  Issue = "Issue",
  Other = "Other",
}
